export default __webpack_public_path__ + "static/media/GoodSmiley.d0875e14.svg";